export enum Sorting {
  FrequencyAscending = "0",
  FrequencyDescending = "1",
  Pillars = "2",
}
